var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPPolicy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FEE3E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66675 15.9998C9.66675 13.0143 9.66675 11.5215 10.5942 10.594C11.5217 9.6665 13.0145 9.6665 16.0001 9.6665C18.9856 9.6665 20.4784 9.6665 21.4059 10.594C22.3334 11.5215 22.3334 13.0143 22.3334 15.9998C22.3334 18.9854 22.3334 20.4782 21.4059 21.4057C20.4784 22.3332 18.9856 22.3332 16.0001 22.3332C13.0145 22.3332 11.5217 22.3332 10.5942 21.4057C9.66675 20.4782 9.66675 18.9854 9.66675 15.9998Z",
    stroke: "#D26662"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66675 16H22.3334",
    stroke: "#D26662",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 12.6665H19.3334",
    stroke: "#D26662",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 13.5002C13.9603 13.5002 14.3334 13.1271 14.3334 12.6668C14.3334 12.2066 13.9603 11.8335 13.5001 11.8335C13.0398 11.8335 12.6667 12.2066 12.6667 12.6668C12.6667 13.1271 13.0398 13.5002 13.5001 13.5002Z",
    stroke: "#D26662",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 20.1667C13.9603 20.1667 14.3334 19.7936 14.3334 19.3333C14.3334 18.8731 13.9603 18.5 13.5001 18.5C13.0398 18.5 12.6667 18.8731 12.6667 19.3333C12.6667 19.7936 13.0398 20.1667 13.5001 20.1667Z",
    stroke: "#D26662",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 19.3335H19.3334",
    stroke: "#D26662",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPPolicy);
export default __webpack_public_path__ + "static/media/pPolicy.e65de35cb34ed8c5b465e83788776b5b.svg";
export { ForwardRef as ReactComponent };